// eTIMS signing modes and the documents waiting on eTIMS (docs/plans/phase3-etims-vscu.md §3).
import { queryOptions } from '@tanstack/react-query';
import {
  etimsDocumentPageSchema,
  etimsDocumentSchema,
  etimsSettingsSchema,
  type EtimsFacilityMode,
} from '@wodi/shared';

import { api } from './client.ts';

export const etimsKeys = {
  all: ['etims'] as const,
  settings: ['etims', 'settings'] as const,
  documents: ['etims', 'documents'] as const,
};

export const etimsSettingsQuery = queryOptions({
  queryKey: etimsKeys.settings,
  queryFn: () => api('GET', '/etims/settings', { schema: etimsSettingsSchema }),
});

export const etimsDocumentsQuery = queryOptions({
  queryKey: etimsKeys.documents,
  queryFn: () => api('GET', '/etims/documents?limit=100', { schema: etimsDocumentPageSchema }),
});

export const saveEtimsMode = (mode: EtimsFacilityMode, reason: string, expectedVersion: number) =>
  api('PUT', '/etims/settings', {
    body: { mode, reason, expectedVersion },
    schema: etimsSettingsSchema,
  });

export const signDocumentAgain = (signingId: string) =>
  api('POST', `/etims/documents/${signingId}/sign-again`, { schema: etimsDocumentSchema });
